import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import {
  LastMileLogFilterForm,
  LastMileLogTable,
} from 'components/logsLastMile'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { Button } from 'components/common'
import { ExportIcon } from 'components/icons'
import { FILTER_FIELD_LAST_MILE_LOG } from 'components/logsLastMile/lastMileLogFilterForm'
import { useQuery } from 'hooks'
import { downloadLastMileLogs } from 'utils/api/logsApi'
import { filterEmptyValues, FilterMeta } from 'utils/helpers'

const LastMileLog = () => {
  const [filterMeta, setFilterMeta] = useState<FilterMeta>()
  const { getQuery } = useQuery()

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = filterEmptyValues(getQuery(FILTER_FIELD_LAST_MILE_LOG))

      await downloadLastMileLogs(
        Object.keys(logFilter).length > 0 ? logFilter : undefined,
      )
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Last Mile Logs</title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Last Mile Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
          <ClearFiltersButton filterKey={FILTER_FIELD_LAST_MILE_LOG} />
        </div>
      </div>

      <LastMileLogFilterForm filterMeta={filterMeta} />
      <LastMileLogTable onFilterMeta={setFilterMeta} />
    </>
  )
}

export default LastMileLog
